import { ModuleWithProviders, NgModule } from "@angular/core";
import {CommonModule} from "@angular/common";

import {
  FileExtensionFromMimePipe,
  FileIconClassPipe,
  FileSizePipe,
  FilterPipe,
  NumberToStringPipe,
  PrefixPipe,
  StateClassPipe,
  StringToNumberPipe,
  SuffixPipe,
  TimeFromNowPipe,
  ToCurrencyPipe,
  ToDatePipe,
  ToNumberPipe,
  CustomPipe,
  TrailingZeroDecimalPipe,
  OrderByPipe, CapitalizePipe, TemplateFilter, TemplateReplacePipe
} from './pipes/custom-pipes';
import { TrustAsPipe } from './pipes/trust-as.pipe';
import { SanitizePipe } from "./pipes/sanitize.pipe";
import { ImagePipe } from "./pipes/image.pipe";

const PIPES = [
  CapitalizePipe,
  FileIconClassPipe,
  FilterPipe,
  FileExtensionFromMimePipe,
  FileSizePipe,
  ToNumberPipe,
  ToDatePipe,
  ToCurrencyPipe,
  PrefixPipe,
  SuffixPipe,
  TimeFromNowPipe,
  NumberToStringPipe,
  StateClassPipe,
  StringToNumberPipe,
  TrailingZeroDecimalPipe,
  TrustAsPipe,
  ImagePipe,
  CustomPipe,
  SanitizePipe,
  OrderByPipe,
  TemplateFilter,
  TemplateReplacePipe
];

const wmComponents: any[] = [];

@NgModule({
  imports: [
    CommonModule,
    ...PIPES
  ],
  declarations: [...wmComponents],
  exports: [...wmComponents, ...PIPES]
})
export class WmComponentsModule {

  static forRoot(): ModuleWithProviders<WmComponentsModule> {
    return {
      ngModule: WmComponentsModule,
      providers: [
        ToDatePipe,
        FilterPipe,
        CapitalizePipe,
        OrderByPipe,
        TrailingZeroDecimalPipe,
        TrustAsPipe,
        ImagePipe,
        CustomPipe,
        SanitizePipe,
        Location,
        // {provide: AbstractDialogService, useClass: DialogServiceImpl}
      ]
    };
  }
}
